export enum ChildCollectionEnum {
  LeaveAlone = 1,
  ParentPickup = 2,
  EighteenAtExamDate = 3,
  SchoolIsResponsibleForChildCollection = 4,
}
